<template>
  <!-- Account Wallet Mobile Page -->
  <div class="w-100">
    <WCSpinner v-if="loading" size="xl" position="center" />
    <!-- START : Display all Saved cards -->
    <template v-if="!loading && wallet">
      <h2 class="wallet__header mb-0">{{ $t('savedCards') }}</h2>
      <!-- START : Display all Saved cards based on token status -->
      <div v-if="wallet.tokenStatus !== 'DISABLED'">
        <div class="wallet-entry" v-if="wallet.tokenStatus === 'OFFLINE'">
          {{ $t('tokenServerUnavailable') }}
        </div>
        <div v-else class="card-display font-size-lg">
          <div class="wallet-entry" v-if="!wallet.tokens || wallet.tokens.length === 0">
            {{ $t('noCards') }}
          </div>
          <!-- START : Wallet card with card image, brand, expiration, default and delete option -->
          <div
            v-for="token of wallet.tokens"
            :key="`${token.id} ${token.finalDigits}`"
            class="card-info row no-gutters align-items-center"
          >
            <div class="col-7 d-flex flex-column">
              <div class="d-flex">
                <font-awesome-icon size="lg" :icon="getFAIcon(token.brand)" />
                <b class="mr-2 ml-2">{{ brandDisplayName(token.brand) }} </b>
                *{{ token.finalDigits }}
              </div>
              <small
                v-if="token.expiration"
                class="d-block"
                :class="checkTokenExpiration(token.expiration) && 'text-danger'"
                >{{ token.expiration | expiration }}</small
              >
            </div>
            <button
              class="card-action-icon col-3 unstyled-btn"
              :disabled="token.defaultToken"
              @click="defaultToken(token)"
            >
              <font-awesome-icon
                class="mb-1"
                :icon="token.defaultToken ? 'star' : ['far', 'star']"
              />
              <span class="font-size-sm font-weight-bold  mt-1">{{
                token.defaultToken ? 'Default' : 'Make Default'
              }}</span>
            </button>
            <button
              class="card-action-icon col-2 unstyled-btn delete-card"
              @click="openDeleteCardContextMenu(token)"
            >
              <div class="ml-auto">
                <font-awesome-icon icon="trash" />
                <div class="font-size-sm font-weight-bold">{{ $t('delete') }}</div>
              </div>
            </button>
          </div>
          <!-- END : Wallet card with card image, brand, expiration, default and delete option -->
        </div>
      </div>
      <!-- END : Display all Saved cards based on token status -->
    </template>
    <!-- END : Display all Saved cards -->
    <div v-if="!loading && error" class="error">{{ error }}</div>
    <!-- START : Add a new card -->
    <div class="wallet-entry py-3">
      <router-link
        class="underline-link-from-center text-primary font-size-lg font-weight-bold"
        to="/me/add-wallet"
      >
        {{ $t('addNewCard') }}
      </router-link>
    </div>
    <!-- END :  Add a new card -->
  </div>
</template>

<script>
import WCSpinner from '@/components/WCSpinner/WCSpinner.vue';
import { MODAL_EVENTS } from '@/constants/EventConstants';
import ModalService from '@/modules/modals/services/modal.service';
import WCConfirmationModal from '@/components/WCConfirmationModal/WCConfirmationModal.vue';
import WalletMixin from '../mixins/WalletMixin';
import WalletFilters from '../filters/WalletFilters';

export default {
  name: 'Wallet',
  components: {
    WCSpinner,
  },
  mixins: [WalletMixin, WalletFilters], // WalletMixin for fetching wallet data on created lifecycle, add wallet, delete wallet, make default option for wallet and wallet details and WalletFilters for expiration format
  methods: {
    /**
     * Method to open mobile context menu for delete confirmation
     * @param {Object} token
     */
    async openDeleteCardContextMenu(token) {
      try {
        const response = await ModalService.open(WCConfirmationModal, {
          headerIcon: 'trash',
          header: this.$t('deleteCard'),
          content: this.$t('areYouSureDelete'),
          contentName: token.finalDigits,
          confirm: this.$t('yesDelete'),
          cancel: this.$t('no'),
        });

        if (response === MODAL_EVENTS.CONFIRM) {
          this.deleteToken(token);
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wallet {
  &__header {
    padding: $pad-3 * 0.75 $pad-3;
    background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
  }
}
.wallet-entry,
.card-info {
  padding: $pad-3 * 0.75 $pad-3 * 1.125;
  color: var(--dark, $dark);
}
.card-info {
  border-bottom: 0.6rem solid var(--gray-200, $gray-200);
}
.card-action-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--primary, $primary);
}
</style>
